import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "fs12 pad10 ddgrey",
  style: {"height":"100px","width":"260px"},
  ref: "EventDetailLi"
}
const _hoisted_3 = { class: "ml8 mt5 w100" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "fl mt5 ml8 fs14 fw600",
  style: {}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "fl mt2 ml8 fs12 arial",
  style: {}
}
const _hoisted_11 = {
  key: 2,
  class: "blackbrownBg rad3 whiteColor padw2 fs10 pointer fl ml8"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = { class: "fl ml8 mt10" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "fl fs11 mt3 ddgrey" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = {
  key: 0,
  role: "separator",
  class: "divider"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"18px","height":"18px"},
  class: "rad6 fl mr5 orangeBg mt2"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 fs11 ddgrey",
  style: {}
}, "可能なイベント名に追加", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"18px","height":"18px"},
  class: "rad6 fl mr5 dblueBg mt2"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 fs11 ddgrey",
  style: {}
}, "無視するイベント名に追加", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"18px","height":"18px"},
  class: "rad6 fl mr5 dblueBg mt2"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 fs11 ddgrey",
  style: {}
}, "枠数を個別に変更", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.ev)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        _createElementVNode("li", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.ev.is_match_available_keyword)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "fl mr5 orangeBg rad6 pointer label whiteColor",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showAvailable && _ctx.showAvailable(...args)))
                }, " 可能イベント "))
              : _createCommentVNode("", true),
            (_ctx.ev.is_match_ignore_keyword)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "fl mr5 dblueBg rad6 pointer label",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showIgnore && _ctx.showIgnore(...args)))
                }, " 無視イベント "))
              : _createCommentVNode("", true),
            _hoisted_4
          ]),
          _hoisted_5,
          (_ctx.Util.isPresent(_ctx.ev.title))
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                (_ctx.ev.title.length >= 15)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.truncate(_ctx.ev.title, 15)), 1)
                      ])), [
                        [_directive_tooltip, `${_ctx.ev.title}`]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.ev.title), 1))
              ]))
            : _createCommentVNode("", true),
          _hoisted_9,
          (!_ctx.ev.allday)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.DateTime.fromSeconds(_ctx.ev.start_time).toFormat(`yyyy/MM/dd HH:mm`)) + " ~ " + _toDisplayString(_ctx.DateTime.fromSeconds(_ctx.ev.start_time + _ctx.ev.duration * 60).toFormat(`HH:mm`)), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_11, [
                _createTextVNode(" 終日予定"),
                (!(_ctx.ev.is_match_available_keyword || _ctx.ev.is_match_ignore_keyword || _ctx.ev.ignore_allday))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "（日程候補をブロックしている可能性があります）"))
                  : _createCommentVNode("", true)
              ])),
          _hoisted_13,
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_circle.png`),
              width: "14",
              height: "15",
              class: "fl mt2 mr6"
            }, null, 8, _hoisted_15),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.calendarName), 1)
          ], 512), [
            [_vShow, _ctx.calendarName]
          ]),
          _createElementVNode("div", {
            class: "fl ml8 mt10 skyblue underline pointer",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
          }, "詳細を表示"),
          _hoisted_17
        ], 512),
        _hoisted_18,
        (_ctx.fromType != `top`)
          ? (_openBlock(), _createElementBlock("li", _hoisted_19))
          : _createCommentVNode("", true),
        (!_ctx.ev.is_match_available_keyword && _ctx.fromType != `top`)
          ? (_openBlock(), _createElementBlock("li", {
              key: 1,
              class: "fs12 pointer fw600 pad10 hoverLgreyBg",
              style: {"line-height":"30px","width":"260px"},
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeAvailableEvent && _ctx.changeAvailableEvent(...args)))
            }, _hoisted_23))
          : _createCommentVNode("", true),
        (!_ctx.ev.is_match_ignore_keyword && _ctx.fromType != `top`)
          ? (_openBlock(), _createElementBlock("li", {
              key: 2,
              class: "fs12 pointer fw600 pad10 hoverLgreyBg",
              style: {"line-height":"30px","width":"260px"},
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeIgnoreEvent && _ctx.changeIgnoreEvent(...args)))
            }, _hoisted_27))
          : _createCommentVNode("", true),
        (_ctx.isSelfMode && (_ctx.rcm?.room?.max_bookings_num || 0) > 1)
          ? (_openBlock(), _createElementBlock("li", {
              key: 3,
              class: "fs12 pointer fw600 pad10 hoverLgreyBg",
              style: {"line-height":"30px","width":"260px"},
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeMaxBookingsNum && _ctx.changeMaxBookingsNum(...args)))
            }, _hoisted_31))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}